 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Admission":"Admission","Applicant":"Applicant","DataApp":"DataApp","Employee":"Employee","Exam":"Exam","ForgetPassword":"ForgetPassword","Mail":"Mail","MyApplication":"MyApplication","NotFound":"NotFound","Profile":"Profile","Tasks":"Tasks","Trems":"Trems","Wallet":"Wallet","paymentOrder":"paymentOrder","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Admission":"b79673a5","Applicant":"6937d791","DataApp":"c745cf0b","Employee":"6e026542","Exam":"1df0460b","ForgetPassword":"14ea8154","Mail":"18405680","MyApplication":"8953f083","NotFound":"b749a67d","Profile":"21b11754","Tasks":"111c4451","Trems":"44901151","Wallet":"96360e0f","chunk-05e536f2":"54772884","chunk-0cfcf769":"18d83234","chunk-10a9d03c":"6efe3020","chunk-15524bca":"6fcbddcb","chunk-1d82d88e":"1c91b75e","chunk-2b0c80b3":"6d0ee1ec","chunk-2d0d8399":"fb069f4c","chunk-dc4d03b2":"3cc5e75c","chunk-2c9efa05":"410f1cac","chunk-48441918":"4af3fafb","chunk-4b6d7d02":"6243cfaa","chunk-56e7897d":"ee08159f","chunk-0ad945b0":"6278bcc3","chunk-cddef2c8":"4241da3a","chunk-d2951150":"e6eed34c","chunk-5b658f04":"0d12f590","chunk-5eba610c":"83d3c578","chunk-7ebf92b4":"af23b1e6","chunk-bc6559fa":"ee001fad","chunk-c0cd7f5a":"24536ccf","chunk-d7a8da00":"317a707e","paymentOrder":"066e10c6","welcome":"4d05f145"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Applicant":1,"DataApp":1,"Exam":1,"ForgetPassword":1,"Mail":1,"MyApplication":1,"NotFound":1,"Profile":1,"Tasks":1,"Trems":1,"Wallet":1,"chunk-05e536f2":1,"chunk-0cfcf769":1,"chunk-10a9d03c":1,"chunk-15524bca":1,"chunk-1d82d88e":1,"chunk-2b0c80b3":1,"chunk-dc4d03b2":1,"chunk-2c9efa05":1,"chunk-48441918":1,"chunk-4b6d7d02":1,"chunk-0ad945b0":1,"chunk-cddef2c8":1,"chunk-d2951150":1,"chunk-5b658f04":1,"chunk-5eba610c":1,"chunk-7ebf92b4":1,"chunk-bc6559fa":1,"chunk-c0cd7f5a":1,"chunk-d7a8da00":1,"paymentOrder":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Admission":"Admission","Applicant":"Applicant","DataApp":"DataApp","Employee":"Employee","Exam":"Exam","ForgetPassword":"ForgetPassword","Mail":"Mail","MyApplication":"MyApplication","NotFound":"NotFound","Profile":"Profile","Tasks":"Tasks","Trems":"Trems","Wallet":"Wallet","paymentOrder":"paymentOrder","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Admission":"31d6cfe0","Applicant":"0a42c335","DataApp":"58b9c73c","Employee":"31d6cfe0","Exam":"e54e4bb8","ForgetPassword":"c9791e1a","Mail":"eaa6341e","MyApplication":"6181e5de","NotFound":"520e4864","Profile":"0bba893f","Tasks":"f9c638b1","Trems":"beeb6953","Wallet":"8dfd8e2f","chunk-05e536f2":"721a0347","chunk-0cfcf769":"f758434d","chunk-10a9d03c":"3422ef7d","chunk-15524bca":"7046511c","chunk-1d82d88e":"3084f5f0","chunk-2b0c80b3":"2450304e","chunk-2d0d8399":"31d6cfe0","chunk-dc4d03b2":"9374f04d","chunk-2c9efa05":"46d07185","chunk-48441918":"be5fcc84","chunk-4b6d7d02":"0217ce13","chunk-56e7897d":"31d6cfe0","chunk-0ad945b0":"78aa6ba1","chunk-cddef2c8":"dc5373d8","chunk-d2951150":"803339d8","chunk-5b658f04":"2450304e","chunk-5eba610c":"7025004f","chunk-7ebf92b4":"83eddce8","chunk-bc6559fa":"cc39f9ee","chunk-c0cd7f5a":"7025004f","chunk-d7a8da00":"a8712016","paymentOrder":"04620838","welcome":"0dba3f93"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
